<template>
  <div class="right-fixed-panel">
    <div class="fixed-content">
      <div class="action-buttons">
        <div
          class="action-item"
          @click="scrollToTop"
        >
          <div class="action-icon">
            <i class="el-icon-caret-top"></i>
          </div>
          <span class="action-text">
            TOP
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
	export default {
		name: 'RightFixedPanel',
		data() {
			return {}
		},
		created() {},
		methods: {
			scrollToTop() {
				window.scrollTo({
					top: 0,
					behavior: 'smooth'
				})
			}
		},
	}
</script>

<style scoped>
	.right-fixed-panel {
		position: fixed;
		top: 50%;
		right: 20px;
		transform: translateY(-50%);
		z-index: 99;
	}

	.fixed-content {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 20px;
	}

	.action-buttons {
		display: flex;
		flex-direction: column;
		align-items: center;
		background-color: white;
		border-radius: 8px;
		box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
		width: 50px;
	}

	.action-item {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		width: 50px;
		padding: 12px 0;
		cursor: pointer;
		transition: all 0.3s ease;
		border-bottom: 1px solid #f0f0f0;
		position: relative;
	}

	.action-icon {
		font-size: 24px;
		color: #808080;
		margin-bottom: 4px;
		transition: color 0.3s ease;
	}

	.action-item:last-child {
		border-bottom: none;
	}

	.action-text {
		font-size: 12px;
		color: #808080;
		text-align: center;
		transition: color 0.3s ease;
	}

	/* 响应式调整 */
	@media (max-width: 768px) {
		.right-fixed-panel {
			right: 30px;
			top: 90%;
		}

		.action-buttons {
			border-radius: 100%;
			width: 50px;
			height: 50px;
			box-shadow: 0 2px 12px rgba(0, 0, 0, 0.5);
		}

		.action-item {
			width: 40px;
			padding: 8px 0;
		}

	}

	@media (max-width: 480px) {
		.right-fixed-panel {
			right: 30px;
			top: 90%;
		}

		.action-buttons {
			border-radius: 100%;
			width: 50px;
			height: 50px;
			box-shadow: 0 2px 12px rgba(0, 0, 0, 0.5);
		}

		.action-item {
			width: 35px;
			padding: 6px 0;
		}

		.action-icon {
			font-size: 20px;
		}

		.action-text {
			font-size: 12px;
			margin-top: -14px;
		}
	}
</style>